define(["require", "exports", "tslib", "vue"], function (require, exports, tslib_1, vue_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EventBusEnum = exports.busEvent = void 0;
    vue_1 = (0, tslib_1.__importDefault)(vue_1);
    var CustomBus = (function () {
        function CustomBus() {
            this.busEvent = new vue_1.default();
        }
        CustomBus.getInstance = function () {
            if (!CustomBus.instance) {
                CustomBus.instance = new CustomBus();
            }
            return CustomBus.instance;
        };
        CustomBus.prototype.getBus = function () {
            return this.busEvent;
        };
        return CustomBus;
    }());
    exports.busEvent = CustomBus.getInstance().getBus();
    var EventBusEnum;
    (function (EventBusEnum) {
        EventBusEnum["APPS_SCENE_FEED_BACK"] = "apps-scene-feed-back";
        EventBusEnum["APPS_SCENE_UPDATE"] = "apps-scene-update";
        EventBusEnum["APPS_THEME_READY"] = "apps-theme-ready";
        EventBusEnum["APPS_TIPS_UPDATE"] = "apps-tips-update";
        EventBusEnum["APPS_OPEN_LOADING"] = "apps-open-loading";
        EventBusEnum["APPS_CLOSE_LOADING"] = "apps-close-loading";
        EventBusEnum["APPS_SHOW_ERROR"] = "apps-show-error";
        EventBusEnum["APPS_SHOW_ERROR_DETAIL"] = "apps-show-error-detail";
        EventBusEnum["APPS_SET_MESSAGER"] = "apps-set-messager";
        EventBusEnum["APPS_FORBIDDEN_CHANGE"] = "apps-403-change";
        EventBusEnum["APPS_FORBIDDEN_CHANGE_DETAIL"] = "apps-403-change-detail";
        EventBusEnum["APPS_LOGIN_CHECK"] = "apps-login-check";
    })(EventBusEnum = exports.EventBusEnum || (exports.EventBusEnum = {}));
});
//# sourceMappingURL=BootstrapBus.js.map